import { takeEvery } from 'redux-saga/effects';
import { selectFallbackLayer } from './select-fallback-layer';
import { selectDefaultLayer } from './select-default-layers';

export function* fetchFilteredLayersSaga() {
  yield takeEvery(['SELECT_FILTER'], selectFallbackLayer);
}

export function* fetchBootupLayersSaga() {
  yield takeEvery(['SELECT_DEFAULT_LAYERS'], selectDefaultLayer);
}
